import Image from 'next/legacy/image';
import router from 'next/router';

import ActionButton from '@source/components/ActionButton';
import * as S from './styles';

const CreateEvent: React.FC = (): JSX.Element => {
  const redirectToWizard = () => router.push('/create-challenge');

  return (
    <S.Container>
      <S.Title>E agora?</S.Title>

      <S.CardsRow>
        <S.Card>
          <S.Number>Passo 01</S.Number>
          <Image
            src="/icons/criar_evento.svg"
            alt="Ícone"
            width={92}
            height={92}
          />
          <S.Text>Crie seu evento</S.Text>
        </S.Card>

        <S.Card>
          <S.Number>Passo 02</S.Number>
          <Image
            src="/icons/megaphone.svg"
            alt="Ícone"
            width={92}
            height={92}
          />
          <S.Text>Divulgue</S.Text>
        </S.Card>

        <S.Card>
          <S.Number>Passo 03</S.Number>
          <Image src="/icons/flag2.svg" alt="Ícone" width={92} height={92} />
          <S.Text>Veja seu desafio acontecer!</S.Text>
        </S.Card>
      </S.CardsRow>

      <ActionButton
        label="Vamos lá?"
        labelcolor="blue"
        style={{ width: '100%', maxWidth: '38rem' }}
        onClick={redirectToWizard}
      />
    </S.Container>
  );
};

export default CreateEvent;
